module.exports = __webpack_public_path__ + "img/Frente-38-02 open.ae31342e.jpg";